


















import Vue from "vue";
import Component from "vue-class-component";
import AppSportEventSlide from "@/components/AppSportEventSlide.vue";
import { mapState } from "vuex";
import i18n from "@/i18n";
import Swiper from "swiper";
import swiperOptions from "./swiper-options";
import SwiperBackgroundLooper from "./swiper-background-looper";
import { DEFAULT_SWIPER_BACKGROUNDS } from "@/constants";
import { HomeState, namespaceHome, HomeActionTypes } from "@/store/home";
import { SwiperModel } from "@/models/swiper.model";
import { SportEvent } from "@/models/sport-events.model";
import { createSrcSet } from "@/utils/lazysizes.utils";

const { swiper, swiperSlide } = require("vue-awesome-swiper");

@Component({
  name: "HomeEventsSwiper",
  computed: {
    ...mapState<HomeState>(namespaceHome, {
      swiperSlides: (state: HomeState) => {
        const swiperBackgroundLooper = new SwiperBackgroundLooper(DEFAULT_SWIPER_BACKGROUNDS);
        return state.mainSportEvents.map<SwiperModel & SportEvent>(sportEvent => {
          const { name, id, image_url, image_urls_resized } = sportEvent;
          return {
            ...sportEvent,
            title: name,
            url: `/events/${id}`,
            backgroundUrl: image_url || swiperBackgroundLooper.getBackground().l,
            image_urls_resized: image_urls_resized || swiperBackgroundLooper.getBackground(),
            buttonText: i18n.tc("read_more")
          };
        });
      }
    })
  },
  methods: {
    createSrcSet: createSrcSet
  },
  mounted() {
    this.$store.dispatch(`${namespaceHome}/${HomeActionTypes.FetchMainSportEvents}`, {});
  },
  data() {
    return {
      swiperOptions
    };
  },
  components: { AppSportEventSlide, swiper, swiperSlide }
})
export default class HomeEventsSwiper extends Vue {}
